import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { Button } from '@medely/ui-kit';
import useDevice from '@mp/hooks/useDevice.web';
import { TaxableModalInfo } from './TaxableModalInfo';
import { TaxableModalProps } from './types';

export const TaxableModal = ({ open, onClose }: TaxableModalProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      title="Taxable income"
      content={<TaxableModalInfo />}
      actions={
        <Button variant="outlined" onClick={onClose} testId="taxable-modal-close-button" fullWidth>
          Close
        </Button>
      }
      isDesktop={isDesktop}
    />
  );
};
